/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useAPIError from '../../../../hooks/useAPIError';
import { TarjetaService } from '../../../../services';
import { TarjetaOroHelper } from '../../TarjetaOroHelper';
import IconBack from '../../../../Icons/IconBack';
// import useAPIError from '../../../hooks/useAPIError';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  numCuentaFormatted?: string;
  iban?: string;
  setReload?: (visible: boolean) => void;
}

const CambioCuentaForm: FC<Props> = (props) => {
  const { visible, setVisible, numCuentaFormatted, setReload, iban } = props;
  const { t } = useTranslation();
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
  });
  const { addError, addWarning, addOro } = useAPIError();

  const goBack = (reload: boolean) => {
    setVisible(false);
    TarjetaOroHelper.resetForm('form-iban');
    reset();
    document.body.classList.remove('fix');
    if (reload && setReload !== undefined) {
      setReload(true);
    }
  };

  const submitForm = () => {
    const nuevoIbanElement = document.getElementById(
      'cuenta',
    ) as HTMLInputElement;
    const nuevoIban = nuevoIbanElement ? nuevoIbanElement.value : '';
    const data = {
      nuevoIban,
    };
    if (iban !== undefined && nuevoIban === iban) {
      addWarning(t('tarjetas.tarjeta-oro-datos.same-acoount'));
    } else {
      addOro(true);
      TarjetaService.cambiarCuentaTarjetaOro(data)
        .then((response) => {
          if (response.data.error === true) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
          } else {
            const { pojo } = response.data;
            if (pojo) {
              const { message } = pojo;
              const { isChanged } = pojo;
              addWarning(message);
              goBack(isChanged);
            }
          }
        })
        .catch((er: any) => {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        });
    }
  };

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById('change-account-btn').click();
    }
  };
  useEffect(() => {
    if (visible) {
      const element = document.querySelector(
        'section.o-section--large.form-iban.bloque-form.tarjetas.visible',
      ) as HTMLElement;
      element.setAttribute('tabindex', '0');
      element.focus();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      element.addEventListener('keydown', saveInfo, false);
    } else {
      const element = document.querySelector(
        'section.o-section--large.form-iban.bloque-form.tarjetas',
      ) as HTMLElement;
      element.removeEventListener('keydown', saveInfo, false);
    }
  });

  return (
    <>
      <section
        className={`o-section--large form-iban bloque-form tarjetas ${
          visible ? 'visible' : ''
        }`}
      >
        <div className="container">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <a
            className="link-prev"
            onClick={() => {
              goBack(false);
            }}
          >
            <div className="icon icon-medium">
              <IconBack />
            </div>
            <p className="u-font-normal u-text-brand u-margin-left">
              {t('tarjetas.tarjeta-oro-datos.back')}
            </p>
          </a>

          <form
            id="form-iban"
            className="form-iban"
            onSubmit={handleSubmit(() => {
              submitForm();
            })}
            noValidate
          >
            <div className="row u-justify-content-center u-margin-bottom">
              <div className="col-12 col-md-6">
                <h2 className="bloque-datos__title u-text-oro">
                  <span className="divider__square brand-gold-color" />
                  <span className="u-margin-right">
                    {t('tarjetas.tarjeta-oro-datos.change-account')}
                  </span>
                </h2>
                <div className="form-control-block u-margin-bottom">
                  <input
                    type="text"
                    className={`form-control ${errors.cuenta ? 'error' : ''}`}
                    id="cuenta"
                    data-rule-required="true"
                    placeholder={
                      numCuentaFormatted !== undefined ? numCuentaFormatted : ''
                    }
                    {...register('cuenta', {
                      required: true,
                      pattern: /^[ES]{2}[0-9]{22}$/,
                    })}
                    maxLength={24}
                  />
                  {errors.cuenta && (
                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                    <label
                      id="numcuenta-error"
                      className="error"
                      htmlFor="cuenta"
                    >
                      {t('validaciones.not-valid-account')}
                    </label>
                  )}
                </div>
              </div>
            </div>

            <div className="u-text-right">
              <button
                id="change-account-btn"
                type="submit"
                className="btn btn-oro"
              >
                {t('tarjetas.tarjeta-oro-datos.update')}
              </button>
            </div>
          </form>
        </div>
      </section>{' '}
    </>
  );
};

export default CambioCuentaForm;
